import { render, staticRenderFns } from "./CapturarImagem.vue?vue&type=template&id=4021fef5&scoped=true"
import script from "./CapturarImagem.vue?vue&type=script&lang=js"
export * from "./CapturarImagem.vue?vue&type=script&lang=js"
import style0 from "./CapturarImagem.vue?vue&type=style&index=0&id=4021fef5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4021fef5",
  null
  
)

export default component.exports